module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBigH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBigH.png
// module id = 236
// module chunks = 0